import axios from "axios";

import {getV1URL} from "./API";

export function remoteFilePath(id) {
  return getV1URL(`file/get/${id}`)
}

export function uploadFile(token, path, title, priority, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("path", path);
  formData.append("title", title);
  formData.append("priority", priority);
  return axios.post(getV1URL("file/upload"), formData, {
      headers: {
          "Authorization": token,
          "Content-Type": "multipart/form-data",
      }
  })
}

export function editFile(token, id, path, title, tag, priority, file) {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("path", path);
  formData.append("title", title);
  formData.append("tag", tag);
  formData.append("priority", priority);
  if (file) {
    formData.append("file", file);
  }
  return axios.put(getV1URL("file/edit"), formData, {
    headers: {
        "Authorization": token,
        "Content-Type": "multipart/form-data",
    }
  });
}

export function visitFile(id) {
  const path = `file/${id}/statistic`;
  return axios.patch(getV1URL(path));
}

export function deleteFile(token, id) {
  const path = `file/delete/${id}`;
  return axios.delete(getV1URL(path), {
    headers: {
        "Authorization": token,
        "Content-Type": "multipart/form-data",
    }
  });
}